import * as yup from 'yup';

const numberTransform = (value: string | number) => (Number.isNaN(value) ? null : value);

export const numberSchemaWithTransform = () => yup.number().transform(numberTransform).nullable();
